<svg
  class="logo-pic"
  data-name="Laag 1"
  id="Laag_1"
  viewBox="0 0 1739.33 468.77"
  xmlns="http://www.w3.org/2000/svg"
>
  <g>
    <path
      d="m109.76,46.47h209.04c26.01,0,47.13,21.12,47.13,47.13h0c0,26.01-21.12,47.13-47.13,47.13H62.63v-47.13c0-26.01,21.12-47.13,47.13-47.13Z"
      [attr.fill]="wls.accentColor"
    />
    <circle cx="103.75" cy="337.97" r="41.12" [attr.fill]="wls.primaryColor" />
    <path
      d="m62.63,173.8h199.17c26.01,0,47.13,21.12,47.13,47.13h0c0,26.01-21.12,47.13-47.13,47.13H109.76c-26.01,0-47.13-21.12-47.13-47.13v-47.13h0Z"
      [attr.fill]="wls.accentColor"
    />
  </g>
  <g>
    <path
      d="m451.21,375.8v-236.69h167.71v51.4h-114.29v50.72h106.51v51.06h-106.51v83.52h-53.42Z"
      [attr.fill]="wls.accentColor"
    />
    <path
      d="m694.66,375.8c-30.09,0-45.99-15.89-45.99-46.66v-200.85h50.04v189.01c0,7.1,3.72,10.48,10.14,10.48h10.48v48.01h-24.68Z"
      [attr.fill]="wls.accentColor"
    />
    <path
      d="m909.03,300.06h-125.11c3.38,24.34,16.91,37.19,42.27,37.19,20.63,0,35.16-10.14,40.58-27.39l40.58,12.51c-13.19,43.62-44.63,56.47-82.84,56.47-52.75,0-90.96-31.11-90.96-88.93s39.56-92.65,91.97-92.65,84.53,33.47,84.53,87.58c0,5.41-.34,9.81-1.01,15.22Zm-122.06-36.52h72.7c-3.38-15.89-15.22-26.04-34.83-26.04-16.91,0-31.45,8.45-37.87,26.04Z"
      [attr.fill]="wls.accentColor"
    />
    <path
      d="m1100.07,375.8h-55.79l-37.87-57.82-38.88,57.82h-51.4l60.19-86.9-60.19-88.25h56.47l35.84,52.07,37.53-52.07h50.38l-58.5,82.84,62.22,92.31Z"
      [attr.fill]="wls.accentColor"
    />
    <path
      d="m1231.6,200.65h50.72l-66.95,190.03c-13.53,40.24-33.47,52.75-66.61,52.75h-35.5v-49.7h32.46c16.91,0,19.61-4.4,22.32-12.51v-.34l-71.34-180.22h55.79l40.91,109.22,38.21-109.22Z"
      [attr.fill]="wls.primaryColor"
    />
    <path
      d="m1288.4,288.23c0-54.78,36.18-90.96,93.32-90.96s92.98,36.18,92.98,90.96-36.86,90.62-92.98,90.62-93.32-35.84-93.32-90.62Zm134.91,0c0-28.06-15.89-45.65-41.59-45.65s-41.93,17.58-41.93,45.65,16.23,45.31,41.93,45.31,41.59-16.91,41.59-45.31Z"
      [attr.fill]="wls.primaryColor"
    />
    <path
      d="m1494.32,288.23c0-54.78,36.18-90.96,93.32-90.96s92.98,36.18,92.98,90.96-36.86,90.62-92.98,90.62-93.32-35.84-93.32-90.62Zm134.91,0c0-28.06-15.89-45.65-41.59-45.65s-41.93,17.58-41.93,45.65,16.23,45.31,41.93,45.31,41.59-16.91,41.59-45.31Z"
      [attr.fill]="wls.primaryColor"
    />
  </g>
</svg>
